import { request } from '../utils/request';
import qs from 'qs';

// 获取列表数据
export async function getListData(current,pagesize) {
  return request(`/project/selectAll?${qs.stringify({pageNum: current,pageSize:pagesize,k:(new Date()).getTime()})}`);
}

// 枚举
export async function enumerationData() {
  return request('/project/selectDictMaps');
}
// 项目详情
export async function currentData(id) {
  return request(`/project/selectOne?${qs.stringify({projectId: id})}`);
}
// 驳回信息
export async function getRejectData(id) {
  return request(`/project/selectAllAuditRecord?${qs.stringify({projectId: id})}`);
}
// 项目名称重复
export async function getProjectTitleData(name,id) {
  return request(`/project/judgeProName?${qs.stringify({projectTitle:name,projectId: id})}`);
}
// 省
export async function getProvinceData() {
  return request('/dict/provinces');
}
// 市
export async function getCityData(city) {
  return request(`/dict/cities?${qs.stringify({provinceCode: city})}`);
}
// 行业领域
export async function getDomainData() {
  return request('/dict/domains');
}
// 行业子领域
export async function getSubDomainData(domain) {
  return request(`/dict/subdomains?${qs.stringify({domainCode: domain})}`);
}
// pdf在线预览
export async function previewPdfData(payload) {
  return request(`/pdf/preview?${qs.stringify(payload)}`);
}
// 提交
export async function submitData(data) {
  let api =`/project/saveAndSubmit?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}
// 暂存
export async function temporaryData(data) {
  let api =`/project/saveAsDraft?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}
// 列表提交
export async function listSubmitData(key) {
  let api =`/project/commitByList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`,
    id = {id:key};
  return request( api, {
    method:'POST',
    body:qs.stringify(id)
  });
}


// 修改基本信息
export async function updateProjcet(data) { 
  let api =`/project/updateProject?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request(api,{
    method:'POST',
    body:qs.stringify(data)
  });
}
// 修改产品信息
export async function saveProduct(data){
  let api = `/project/saveProduct?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request(api,{
    method:'POST',
    body:qs.stringify(data)
  });
}
// 修改创始团队
export async function updateTeam(data){
  let api = `/project/updateTeam?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request(api,{
    method:'POST',
    body:qs.stringify(data)
  });
}
// 修改新增融资信息
export async function saveFinance(data){
  let api = `/project/saveFinance?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request(api,{
    method:'POST',
    body:qs.stringify(data)
  });
}
// 删除融资信息
export async function deleteFinance(id){
  return request(`/project/deleteFinance?${qs.stringify({id})}`);
}
// 修改添加项目报道
export async function saveReport(data){
  let api = `/project/saveReport?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;  
  return request(api,{
    method:'POST',
    body:qs.stringify(data)
  });
}
// 删除项目报道
export async function deleteNewsReport(id){
  return request(`/project/deleteNewsReport?${qs.stringify({id})}`);
}

// 申请园区记录详情
export async function parkApplyDetail(data){
  return request(`/api/incubator/manage/latestApplyRecord?${qs.stringify(data)}`);
}













//园区

// 获取列表数据
// export async function getListData(current,pagesize) {
//   return request(`/project/selectAll?${qs.stringify({
//   pageNum: current,pageSize:pagesize,k:(new Date()).getTime()
// })}`);
// }
// // 枚举
// export async function enumerationData() {
//   return request('/project/selectDictMaps');
// }
// // 列表提交
// export async function listSubmitData(key) {
//   let api =`/project/commitByList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`,
//     id = {id:key};
//   return request( api, {
//     method:'POST',
//     body:qs.stringify(id)
//   });
// }
//园区列表页tab获取
export async function getParkList(city) {
  return request(`/park/queryParkBaseInfoByCity?${qs.stringify({region: city})}`);
}
// 园区详情获取
export async function queryParkInfo(city) {
  return request(`/park/queryParkInfo?${qs.stringify({parkId:city})}`);
}

// 申请页权限
export async function checkUserApply() {
  return request('/park/checkUserApply');
}

// 申请页手机号是否填写
export async function checkUserIsHavePhone() {
  return request('/api/incubator/checkUserIsHavePhone');
}

// 获取当前认证状态
export async function getCurrentStatus(){
  return request('/api/invest/checkUserIsRealName');
}

// 园区入驻
export async function parkApply(msg) {
  let api =`/park/parkApply?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(msg)
  });
}

//获取用户项目列表
export async function getUserAllProject() {
  return request('project/getUserAllProject');
}

//根据用户所选项目获取基本数据
export async function selectBaseOne(projectId) {
  return request(`project/selectBaseOne?${qs.stringify({projectId:projectId})}`);
}

//行业领域
export async function domains() {
  return request('/dict/domains');
}

// 行业子领域
export async function subdomains(domain) {
  return request(`/dict/subdomains?${qs.stringify({domainCode: domain})}`);
}

//省
export async function provinces() {
  return request('/dict/provinces');
}

//市
export async function cities(provinceCode) {
  return request(`/dict/cities?${qs.stringify({provinceCode:provinceCode})}`);
}

// 添加园区
export async function addParkInfo(data) {
  let api =`/parkAdmin/addParkInfo?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//申请园区列表
export async function parkApplyList(data) {
  let api =`/parkAdmin/parkApplyList?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//申请园区列表审核
export async function auditApply(data) {
  let api =`/parkAdmin/auditApply?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//园区入驻列表
export async function parkEnterList(data) {
  return request(`/parkEnter/list?${qs.stringify(data)}`);
}

//入驻企业-企业入驻
export async function parkEnterEnter(id) {
  let api =`/parkEnter/enter?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify({id:id})
  });
}

//入驻企业-企业搬离
export async function parkEnterLeave(id) {
  let api =`/parkEnter/leave?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify({id:id})
  });
}

//添加入驻项目
export async function submitProject(data) {
  let api =`/parkEnter/submitProject?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    body:qs.stringify(data)
  });
}

//添加入驻项目-根据用户名查询pk
export async function searchAliyunPK(aliyunID) {
  return request(`/parkEnter/searchAliyunPK?${qs.stringify({aliyunID:aliyunID})}`);
}

// 查询园区信息(后台)
export async function getParkInfo() {
  return request('/parkAdmin/queryParkInfo');
}

//园区管理信息更新
export async function updateParkInfo(data) {
  let api =`/parkAdmin/updateParkInfo?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
  return request( api, {
    method:'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body:JSON.stringify(data)
  });
}

// 园区官网所属列表
export async function queryParkFromCity() {
  return request('/park/getAllParkIdAndName');
}

// //获取用户手机号
// export async function seePhone(id) {
//   // return request(`/api/user/record/seePhone?${qs.stringify({id:id})}`);

//   let api = `/api/user/record/seePhone?p_csrf=${window.GLOBAL_CONFIG.csrf_val}`;
//   return request( api, {
//     method:'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body:JSON.stringify({id:id})
//   });
// }


// WEBPACK FOOTER //
// ./src/scripts/services/home.js